// Популярные домены, на которые исправляются опечатки.
// Порядок важен: при равном расстоянии выигрывает домен, стоящий выше.
export const KNOWN_DOMAINS = [
  'gmail.com',
  'mail.ru',
  'yandex.ru',
  'bk.ru',
  'list.ru',
  'inbox.ru',
  'internet.ru',
  'rambler.ru',
  'ya.ru',
  'icloud.com',
  'outlook.com',
  'hotmail.com',
  'yahoo.com',
  'live.com',
  'vk.com',
];

// Реально существующие домены, которые нельзя считать опечаткой.
// Включает региональные домены провайдеров (yandex.by, yandex.kz, mail.kz и т.п.).
export const VALID_DOMAINS = [
  ...KNOWN_DOMAINS,
  'yandex.by',
  'yandex.kz',
  'yandex.ua',
  'yandex.com',
  'yandex.com.tr',
  'ya.by',
  'ya.kz',
  'mail.ua',
  'mail.by',
  'mail.kz',
  'mail.com',
  'gmail.com.ua',
  'googlemail.com',
  'ymail.com',
  'rocketmail.com',
  'yahoo.co.uk',
  'yahoo.com.tr',
  'hotmail.co.uk',
  'hotmail.fr',
  'outlook.com.tr',
  'live.ru',
  'msn.com',
  'me.com',
  'proton.me',
  'protonmail.com',
  'tutanota.com',
  'tuta.io',
  'aol.com',
  'gmx.com',
  'gmx.de',
  'web.de',
  'zoho.com',
  'fastmail.com',
  'qip.ru',
  'pochta.ru',
  'nm.ru',
  'tut.by',
  'ukr.net',
  'i.ua',
  'meta.ua',
  'sibmail.com',
  'narod.ru',
];

// Опечатки из выгрузки MO_Socdem_by_utm: домены, которые фаззи-поиск
// не ловит (расстояние больше порога) или ловит с неверным результатом.
export const DOMAIN_TYPOS = {
  'gmail.con': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.cm': 'gmail.com',
  'gmail.om': 'gmail.com',
  'gmail.vom': 'gmail.com',
  'gmail.kom': 'gmail.com',
  'gmail.koc': 'gmail.com',
  'gmail.ru': 'gmail.com',
  'gmail.net': 'gmail.com',
  'gmail.come': 'gmail.com',
  'gmail.comi': 'gmail.com',
  'gmail.comd': 'gmail.com',
  'gmail.coms': 'gmail.com',
  'gmail..com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmaii.com': 'gmail.com',
  'yndex.ru': 'yandex.ru',
  'yanex.ru': 'yandex.ru',
  'yandex.ry': 'yandex.ru',
  'yandex.tu': 'yandex.ru',
  'yandex.rn': 'yandex.ru',
  'yandex.rh': 'yandex.ru',
  'yandex.r': 'yandex.ru',
  'yandex.com.ru': 'yandex.ru',
  'mail.ry': 'mail.ru',
  'mail.ri': 'mail.ru',
  'mail.tu': 'mail.ru',
  'mail.re': 'mail.ru',
  'mail.r': 'mail.ru',
  'mail.rum': 'mail.ru',
};

// Типовые опечатки доменной зоны. Исправление применяется только если
// получившийся домен есть в списке существующих (VALID_DOMAINS).
export const TLD_TYPOS = {
  con: ['com'],
  cm: ['com'],
  co: ['com'],
  om: ['com'],
  vom: ['com'],
  kom: ['com'],
  koc: ['com'],
  xom: ['com'],
  som: ['com'],
  dom: ['com'],
  ocm: ['com'],
  cpm: ['com'],
  cim: ['com'],
  clm: ['com'],
  comm: ['com'],
  comn: ['com'],
  coom: ['com'],
  ccom: ['com'],
  coma: ['com'],
  come: ['com'],
  comu: ['com'],
  cop: ['com'],
  ry: ['ru'],
  ri: ['ru'],
  tu: ['ru'],
  re: ['ru'],
  r: ['ru'],
  rn: ['ru'],
  rh: ['ru'],
  rum: ['ru'],
  ruu: ['ru'],
  rru: ['ru'],
  rы: ['ru'],
};

// Кириллические символы, визуально совпадающие с латиницей: на мобильной
// клавиатуре легко набрать домен со смешанной раскладкой.
const CONFUSABLE_CHARS = {
  а: 'a',
  в: 'b',
  е: 'e',
  ё: 'e',
  к: 'k',
  м: 'm',
  н: 'h',
  о: 'o',
  р: 'p',
  с: 'c',
  т: 't',
  у: 'y',
  х: 'x',
  і: 'i',
  ј: 'j',
  ѕ: 's',
  ԁ: 'd',
  ԛ: 'q',
  ԝ: 'w',
};

// Русская раскладка: домен, набранный без переключения языка (mail.кг → mail.ru).
const KEYBOARD_LAYOUT_CHARS = {
  й: 'q', ц: 'w', у: 'e', к: 'r', е: 't', н: 'y', г: 'u', ш: 'i', щ: 'o', з: 'p',
  ф: 'a', ы: 's', в: 'd', а: 'f', п: 'g', р: 'h', о: 'j', л: 'k', д: 'l',
  я: 'z', ч: 'x', с: 'c', м: 'v', и: 'b', т: 'n', ь: 'm',
};

const VALID_DOMAIN_SET = new Set(VALID_DOMAINS);
const KNOWN_DOMAINS_BY_LENGTH = [...KNOWN_DOMAINS].sort((a, b) => b.length - a.length);

function remapChars(domain, map) {
  let result = '';
  for (const char of domain) {
    result += map[char] || char;
  }
  return result;
}

function latinize(domain) {
  return remapChars(domain, CONFUSABLE_CHARS);
}

// Расстояние Дамерау — Левенштейна (без учёта повторных перестановок):
// перестановка соседних символов считается за одну ошибку — самый частый
// случай при быстром наборе (gmial.com).
export function damerauLevenshtein(a, b, limit = Infinity) {
  if (a === b) return 0;
  if (Math.abs(a.length - b.length) > limit) return limit + 1;

  const rows = [];
  for (let i = 0; i <= a.length; i++) {
    rows.push(new Array(b.length + 1).fill(0));
    rows[i][0] = i;
  }
  for (let j = 0; j <= b.length; j++) {
    rows[0][j] = j;
  }

  for (let i = 1; i <= a.length; i++) {
    let rowMin = Infinity;
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      let value = Math.min(
        rows[i - 1][j] + 1,
        rows[i][j - 1] + 1,
        rows[i - 1][j - 1] + cost,
      );
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        value = Math.min(value, rows[i - 2][j - 2] + 1);
      }
      rows[i][j] = value;
      if (value < rowMin) rowMin = value;
    }
    if (rowMin > limit) return limit + 1;
  }

  return rows[a.length][b.length];
}

function maxDistanceFor(domain) {
  if (domain.length <= 4) return 0;
  if (domain.length <= 8) return 1;
  return 2;
}

// Домен начинается с известного, но за ним идёт «мусор» без точки:
// gmail.com97816, gmail.commayina, gmail.com??????
function findTrailingGarbageMatch(domain) {
  for (const known of KNOWN_DOMAINS_BY_LENGTH) {
    if (domain.length <= known.length || !domain.startsWith(known)) continue;
    const tail = domain.slice(known.length);
    if (tail.includes('.')) continue;
    return known;
  }
  return null;
}

function fixTld(domain) {
  const lastDot = domain.lastIndexOf('.');
  if (lastDot <= 0) return null;

  const name = domain.slice(0, lastDot);
  const tld = domain.slice(lastDot + 1);
  const candidates = TLD_TYPOS[tld];
  if (!candidates) return null;

  for (const candidate of candidates) {
    const fixed = `${name}.${candidate}`;
    if (VALID_DOMAIN_SET.has(fixed)) return fixed;
  }
  return null;
}

function findClosestDomain(domain) {
  const limit = maxDistanceFor(domain);
  if (limit === 0) return null;

  let best = null;
  let bestDistance = limit + 1;

  for (const known of KNOWN_DOMAINS) {
    const distance = damerauLevenshtein(domain, known, limit);
    if (distance < bestDistance) {
      best = known;
      bestDistance = distance;
    }
  }

  return bestDistance <= limit ? best : null;
}

export function suggestDomainCorrection(rawDomain) {
  if (!rawDomain) return null;

  const domain = rawDomain.toLowerCase();
  if (VALID_DOMAIN_SET.has(domain)) return null;

  const latin = latinize(domain);
  if (latin !== domain && VALID_DOMAIN_SET.has(latin)) return latin;

  const relayouted = remapChars(domain, KEYBOARD_LAYOUT_CHARS);
  if (relayouted !== domain && VALID_DOMAIN_SET.has(relayouted)) return relayouted;

  const suggestion =
    DOMAIN_TYPOS[domain] ||
    DOMAIN_TYPOS[latin] ||
    findTrailingGarbageMatch(latin) ||
    fixTld(latin) ||
    findClosestDomain(latin);

  return suggestion && suggestion !== domain ? suggestion : null;
}

/**
 * Ищет опечатку в доменной части email.
 * Возвращает null, если домен корректен либо непохож ни на один известный.
 */
export function suggestEmailCorrection(email) {
  if (typeof email !== 'string') return null;

  const value = email.trim();
  const separator = value.lastIndexOf('@');
  if (separator <= 0 || separator === value.length - 1) return null;

  const local = value.slice(0, separator);
  const rawDomain = value.slice(separator + 1);
  if (!rawDomain.includes('.')) return null;

  const domain = suggestDomainCorrection(rawDomain);
  if (!domain) return null;

  return {
    email: `${local}@${domain}`,
    local,
    domain,
    originalEmail: value,
    originalDomain: rawDomain.toLowerCase(),
  };
}
